import { TextButtonProps } from '../components/text-button';

export const isTextButtonProps = (buttonProps: unknown): buttonProps is TextButtonProps =>
  ['primary', 'secondary', 'hyperlink', 'ghost', 'primary-lime', 'primary-brabus'].includes(
    (buttonProps as TextButtonProps)?.variant
  ) && typeof (buttonProps as TextButtonProps)?.children === 'string';
